module.exports = __webpack_public_path__ + "static/media/card-tc.dac84268.jpg";